import { getCurrentConfig } from '@core/observables/configForNetwork'
import { isSameEthereumAddress } from '@core/web3'

const { xGoldKgAddress, xGoldOzAddress, xGoldBundleAddress } =
  getCurrentConfig()

export const isXGoldKgByAddress = (address: string) =>
  isSameEthereumAddress(xGoldKgAddress, address)

export const isXGoldOzByAddress = (address: string) =>
  isSameEthereumAddress(xGoldOzAddress, address)

export const isXGoldNftByAddress = (address: string) =>
  isXGoldKgByAddress(address) || isXGoldOzByAddress(address)

export const isXGoldByAddress = (address: string) =>
  isSameEthereumAddress(xGoldBundleAddress, address)
